import React from 'react'
import { useTranslation } from 'react-i18next'
import { FarmerCo2Type } from '~/api/services/co2'
import Dialog from '~/components/Dialog'
import { Nullable } from '~/types'

interface Props {
  farmersData: Nullable<FarmerCo2Type>
  handleClose: (submited?: boolean) => void
}

const RecalculateModal: React.FC<Props> = ({ farmersData, handleClose }) => {
  const { t } = useTranslation()

  return <Dialog
    open={Boolean(farmersData)}
    handleClose={() => handleClose()}
    textContent={<div dangerouslySetInnerHTML={{
      __html: `Bitte beachten Sie, dass alle bisher kalkulierten Werte  überschrieben und ersetzt werden. 
      Möchten Sie wirklich die Datenerhebung für ${farmersData?.companyName || ''} neu berechnen?`
    }} />}
    textHeader={'Neuberechnung Datenerhebung'}
    textClose={t('Cancel')}
    textSubmit={'Neu berechnen'}
    handleSubmit={() => handleClose(true)}
    type={'abort'}
  />
}
export default RecalculateModal